// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__aMqYL","image":"NotFound_image__vt5OK","containerInfo":"NotFound_containerInfo__ewzc9","title":"NotFound_title__u4rJJ","info":"NotFound_info__wbD4s"};